import React, { useEffect, useState } from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'
import { Link } from "react-router-dom"
import meetingsData from '../components/Meetings.json'
import MeetingTable from '../components/MeetingTable'

export default function Meetings() {
    /* SAMPLE JSON FROM MEETINGS.JS
    {
        "Date": "04/17/2024",
        "Notices": {
            "Title": "Notice",
            "Link": "../assets/documents/meetings/"
        },
        "Agendas": [
            {
                "Title": "Agenda",
                "Link": "../assets/documents/meetings/"
            }
        ],
        "Meeting Materials": [
            {
                "Title": "Meeting Materials",
                "Link": "../assets/documents/meetings/"
            }
        ],
        "Minutes": [
            {
                "Title": "Final",
                "Link": "../assets/documents/meetings/"
            }
        ],
        "Year": "2024"
    }
    */
    const [tableData, setTableData] = useState([]);

    const initData = function () {
        var tempData = {};

        for (let i = 0; i < meetingsData.length; i++) {
            const year = meetingsData[i].Year;
            if (!tempData[year]) {
                tempData[year] = [];
            }
            tempData[year].push(meetingsData[i]);
        }

        var tempTables = [];
        for (var year in tempData) {
            const sortedData = tempData[year].sort((a, b) => new Date(b.Date) - new Date(a.Date));
            tempTables.unshift(<MeetingTable Year={year} Data={sortedData} />);
        }
        setTableData(tempTables);
    }

    useEffect(() => {
        initData();
    }, [])

    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container'>
                    <div className='row ps-lg-4'>
                        <h3>Meetings</h3>
                        <p>
                            The Regional Planning process is a grassroots approach to water planning in Texas. As a key component of this process, Region H promotes community involvement in its public forum.
                            This page provides information regarding notices of public meetings and hearings, agendas for upcoming events, and minutes from past Region H events.
                        </p>
                        <p>Meeting Notices will also be posted on the <Link to="/Calendar">calendar.</Link></p>
                    </div>
                    <div className='row px-lg-5 px-3'>
                        {tableData}
                    </div>
                    <div className='row ps-lg-5 mb-5'>
                        <Link to="/MeetingsArc" ><h5>Archive</h5></Link>
                    </div>
                </div>
            </main>

        </div>
    )
}
